import { Inject, Pipe, PipeTransform } from '@angular/core';
import { CHAT_ASSET_BASE_URL } from '../tokens/chat-asset-base-url.token';
import { SharedHelpers } from '../classes/sharedhelpers';

@Pipe({
  name: 'chatAssetUrl',
  standalone: false
})
export class ChatAssetUrlPipe implements PipeTransform {
  constructor(@Inject(CHAT_ASSET_BASE_URL) private baseUrl: string) {}

  transform(path: string): string {
    return SharedHelpers.resolveAssetUrl(this.baseUrl, path);
  }
}
